import { useState, useEffect, forwardRef } from 'react';
import { get } from 'lodash';
import { TaskItem } from './taskItem';
import { useDeal } from './context';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { COLOR_GROUPS_RAW } from '../utils/colors';
import { uniq } from 'lodash';

const nestedDivClasses =
  '[&>div:not(.checkbox)]:px-[0.8rem] [&>div]:py-1 [&>div]:truncate [&>div>span]:truncate';

const TaskItemGroup = forwardRef(({ groupId, mode }, ref) => {
  const { taskGroupById, gridCols, toggleGroup, closedGroupIds, searchedTaskItemIds } = useDeal();

  const group = get(taskGroupById, groupId);
  const sortedTaskItemIds = get(group, 'task_items', []).map(t => t.id);

  const [taskItemIds, setTaskItemIds] = useState(sortedTaskItemIds);
  const colors = get(COLOR_GROUPS_RAW, group.color, COLOR_GROUPS_RAW.default);
  const colorClasses = Object.values(colors).join(' ');
  const dividerClass = 'divide-slate-200';

  useEffect(() => {
    if (sortedTaskItemIds.length !== taskItemIds.length) {
      setTaskItemIds(sortedTaskItemIds);
    }
  }, [sortedTaskItemIds]);

  const label = get(group, 'label');
  const openedGroup = !closedGroupIds.includes(String(groupId));
  const menuIconClasses = 'w-5 h-5';

  return (
    <div
      ref={ref}
      data-id={groupId}
      className={`group/group relative shadow-lg flex flex-col divide-y rounded-lg overflow-hidden border ${colorClasses}`}
    >
      <div className="group flex items-center relative justify-between px-4 py-2">
        <div className="font-hmedium w-full flex-shrink">{label}</div>
        <div className="flex items-center space-x-4">
          <button onClick={() => toggleGroup(groupId)}>
            {openedGroup ? (
              <ChevronDownIcon className={menuIconClasses} />
            ) : (
              <ChevronUpIcon className={menuIconClasses} />
            )}
          </button>
        </div>
      </div>
      <div
        className={`${openedGroup ? 'block' : 'hidden'} divide-x grid ${gridCols} ${dividerClass} ${nestedDivClasses} [&>div]:text-xs bg-slate-50 font-hmedium [&>div>span]:text-slate-600`}
      >
        <div>
          <span>Nom</span>
        </div>
        <div className="hidden lg:inline-flex items-center justify-center">
          <span>Fichiers</span>
        </div>
        <div className="inline-flex items-center justify-center">
          <span>Statut</span>
        </div>
        <div className="inline-flex items-center justify-center">
          <span>Échéances</span>
        </div>
        <div className="hidden lg:inline-flex items-center justify-center">
          <span>Initiateur</span>
        </div>
      </div>

      {taskItemIds.length > 0 && (
        <div
          className={`flex flex-col divide-y bg-white ${dividerClass} ${openedGroup ? 'flex' : 'hidden'}`}
        >
          {uniq(taskItemIds).map(taskItemId => (
            <TaskItem
              classes={`${nestedDivClasses} ${gridCols}`}
              taskItemId={taskItemId}
              key={taskItemId}
              mode={mode}
            />
          ))}
        </div>
      )}
      {taskItemIds.length < 0 && (
        <div className="w-full min-h-[400px] flex items-center justify-center border-2 border-dashed rounded-lg">
          <div className="font-hmedium text-gray-400">Aucune démarche</div>
        </div>
      )}
    </div>
  );
});

export default TaskItemGroup;
